/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_SuccessInputs */

const en_work_order_publish_success = /** @type {(inputs: Work_Order_Publish_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`External work order publish was successful.`)
};

const fr_work_order_publish_success = /** @type {(inputs: Work_Order_Publish_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La publication de l’ordre de travail externe a réussi.`)
};

const de_work_order_publish_success = /** @type {(inputs: Work_Order_Publish_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Veröffentlichung des externen Arbeitsauftrags war erfolgreich.`)
};

const it_work_order_publish_success = /** @type {(inputs: Work_Order_Publish_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La pubblicazione dell'ordine di lavoro esterno è avvenuta correttamente.`)
};

const ru_work_order_publish_success = /** @type {(inputs: Work_Order_Publish_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Публикация внешнего задания прошла успешно.`)
};

const es_work_order_publish_success = /** @type {(inputs: Work_Order_Publish_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La publicación de la orden de trabajo externa fue exitosa.`)
};

const zh_cn2_work_order_publish_success = /** @type {(inputs: Work_Order_Publish_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外部工单发布成功。`)
};

const ja_work_order_publish_success = /** @type {(inputs: Work_Order_Publish_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外部作業指示書の公開が成功しました。`)
};

const hi_work_order_publish_success = /** @type {(inputs: Work_Order_Publish_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बाह्य कार्य आदेश का प्रकाशन सफलतापूर्वक हो गया।`)
};

const pt_pt2_work_order_publish_success = /** @type {(inputs: Work_Order_Publish_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A publicação da ordem de serviço externa foi bem-sucedida.`)
};

/**
* | output |
* | --- |
* | "External work order publish was successful." |
*
* @param {Work_Order_Publish_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_success = /** @type {((inputs?: Work_Order_Publish_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_success(inputs)
	if (locale === "de") return de_work_order_publish_success(inputs)
	if (locale === "it") return it_work_order_publish_success(inputs)
	if (locale === "ru") return ru_work_order_publish_success(inputs)
	if (locale === "es") return es_work_order_publish_success(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_success(inputs)
	if (locale === "ja") return ja_work_order_publish_success(inputs)
	if (locale === "hi") return hi_work_order_publish_success(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_success(inputs)
	return en_work_order_publish_success(inputs)
});